(() => {
  'use strict';
  if (window.__hcSimpleViewLoaded) return;
  window.__hcSimpleViewLoaded = true;
  const key = 'holdcom:browsing-view:v1';
  const mobile = matchMedia('(max-width: 749px)');
  const root = document.documentElement;
  let explicitPreference = readPreference();
  const resolvedPreference = () => explicitPreference || (mobile.matches ? 'simple' : 'standard');
  let preference = resolvedPreference();
  let opener;
  let trackedMode;
  let memorySession;
  let visitorId;
  const sessionKey = 'framewerk:analytics-session:v1';
  const entryKey = 'holdcom:mode-session-entry:v1';
  // Capture the functional entry state before hydration, resize or a choice.
  // Persist it only alongside the existing consent-eligible analytics session.
  const entryCandidate = mobile.matches && !explicitPreference ? 'mobile-default-simple' : 'other';
  let sessionEntry;
  let activeSince = performance.now();
  let lastActivity = activeSince;
  let foreground = !document.hidden && document.hasFocus();
  let interval = modeInterval();
  function analyticsAllowed() {
    return !(window.Shopify?.designMode || (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main') || navigator.webdriver || new URLSearchParams(location.search).has('preview_theme_id') || /(?:^|; )framewerk_analytics_excluded=1(?:;|$)/.test(document.cookie)) && !!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.();
  }
  function modeInterval() {
    return { eligible: mobile.matches && foreground && analyticsAllowed(), mode: preference === 'simple' ? 'simple' : 'standard' };
  }
  function resetModeInterval() { activeSince = performance.now(); interval = modeInterval(); }
  function flushModeTime() {
    const now = performance.now();
    const duration = interval.eligible ? Math.max(0, Math.min(now, lastActivity + 60000) - activeSince) : 0;
    activeSince = now;
    // Attribute the previous interval even after matchMedia has changed. The
    // live consent check in sendMode drops any unsent tail after revocation.
    if (duration >= 1) sendMode('engaged', interval.mode, { activeMs: Math.min(60000, Math.round(duration)) });
  }
  function sendMode(type, mode, metadata = {}) {
    if (!analyticsAllowed()) return;
    const id = () => 'mode:' + (window.crypto?.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2));
    const validVisitor = value => typeof value === 'string' && /^mode:[a-zA-Z0-9-]{8,80}$/.test(value);
    try { const saved = localStorage.getItem('holdcom:mode-visitor:v1'); visitorId = validVisitor(saved) ? saved : visitorId || id(); localStorage.setItem('holdcom:mode-visitor:v1', visitorId); } catch { visitorId ||= id(); }
    let session = memorySession;
    let existing;
    try { existing = sessionStorage.getItem(sessionKey); } catch {}
    if (typeof existing === 'string' && /^[A-Za-z0-9:_-]{8,100}$/.test(existing)) session = existing;
    if (!session) session = id();
    if (!sessionEntry || sessionEntry.sessionId !== session) {
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem(entryKey)); } catch {}
      const valid = saved?.version === 1 && saved.sessionId === session && ['mobile-default-simple', 'other', 'unknown'].includes(saved.entry);
      // An existing session without an entry record predates this contract (or
      // belongs to another runtime). Do not infer its origin from this page.
      sessionEntry = valid ? saved : { version: 1, sessionId: session, entry: existing || memorySession ? 'unknown' : entryCandidate };
    }
    try { sessionStorage.setItem(sessionKey, session); sessionStorage.setItem(entryKey, JSON.stringify(sessionEntry)); } catch {}
    memorySession = session;
    fetch('/apps/framewerk?resource=analytics', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventId: id(), eventName: 'framewerk.browsing-mode.' + type + '.v1', eventVersion: 1, anonymousSessionId: session, occurredAt: new Date().toISOString(), metadata: { visitorId, ...metadata, browsingMode: mode, modeEntryVersion: 1, modeSessionEntry: sessionEntry.entry, device: 'mobile', surface: 'storefront', pageType: document.querySelector('#MainContent')?.dataset.template || 'other' } })
    }).catch(() => {});
  }
  function trackMode(source = 'sync') {
    if (!mobile.matches || !analyticsAllowed()) return;
    const mode = preference === 'simple' ? 'simple' : 'standard';
    if (mode === trackedMode) return;
    const previous = trackedMode;
    trackedMode = mode;
    sendMode(previous ? 'changed' : 'viewed', mode, previous ? { previousMode: previous, modeChangeSource: source } : {});
  }
  function readPreference() {
    try { const value = localStorage.getItem(key); if (['simple', 'standard'].includes(value)) return value; } catch {}
    try { return document.cookie.match(/(?:^|; )hc_browsing_view=(simple|standard)(?:;|$)/)?.[1] || null; } catch { return null; }
  }
  let homepageHeroPosition;
  function syncHomepageHero() {
    const main = document.querySelector('#MainContent[data-template="index"]');
    const hero = main?.querySelector(':scope > [id*="__slideshow"]');
    const tools = main?.querySelector(':scope > .hc-simple-tools');
    if (homepageHeroPosition && homepageHeroPosition.parentNode !== main) {
      homepageHeroPosition.remove(); homepageHeroPosition = null;
    }
    if (!hero) return;
    hero.querySelectorAll('.slide__content .text-block').forEach(block => {
      const brand = block.textContent.trim().replace(/\s+/g, ' ').toUpperCase() === 'HOLDCOM AUTO PARTS';
      block.toggleAttribute('data-hc-simple-hero-brand', brand);
      block.closest('.dynamic-text-highlight')?.toggleAttribute('data-hc-simple-hero-brand', brand);
    });
    const slides = hero.querySelector('.slideshow--content-on-media > slideshow-container > slideshow-slides');
    if (slides) {
      // Wrapped copy can exceed the theme's minimum height. Measure the same
      // slide in its normal styling, restoring Simple before the next paint.
      const simple = root.classList.contains('hc-simple-view');
      if (simple) root.classList.remove('hc-simple-view');
      const height = slides.getBoundingClientRect().height;
      if (simple) root.classList.add('hc-simple-view');
      if (height > 0) slides.style.setProperty('--hc-simple-hero-normal-height', height + 'px');
    }
    if (preference !== 'simple' || !mobile.matches) {
      if (homepageHeroPosition) { homepageHeroPosition.replaceWith(hero); homepageHeroPosition = null; }
      return;
    }
    if (!tools) return;
    // The tools panel fills the first mobile screen. Keep the hero above it,
    // and remember its theme position for normal mode and wider screens.
    if (!homepageHeroPosition) {
      homepageHeroPosition = document.createComment('hc-simple-hero-position');
      hero.before(homepageHeroPosition);
    }
    if (hero.nextElementSibling !== tools) tools.before(hero);
  }
  const categoryParam = 'filter.p.m.jci.categories';
  const categoryText = new WeakMap();
  let categoryGroup;
  let categoryToolbar;
  let categoryToolbarPosition;
  function syncCategoryToolbar() {
    const tools = document.querySelector('#MainContent:is([data-template^="collection"], [data-template^="search"]) .hc-simple-tools');
    const incoming = [...document.querySelectorAll('.framewerk-sticky-shell--mobile[data-framewerk-sticky-shell]')].find(shell => shell !== categoryToolbar);
    // A section render owns a fresh toolbar. Discard the moved old section's
    // node rather than leaving two copies, or restoring it into the new section.
    if (categoryToolbar && (!categoryToolbarPosition?.isConnected || !categoryToolbar.isConnected || incoming)) {
      categoryToolbar.remove(); categoryToolbarPosition?.remove();
      categoryToolbar = null; categoryToolbarPosition = null;
    }
    if (preference !== 'simple' || !mobile.matches || !tools) {
      if (categoryToolbarPosition) categoryToolbarPosition.replaceWith(categoryToolbar);
      categoryToolbar = null; categoryToolbarPosition = null; return;
    }
    const shell = incoming || categoryToolbar;
    if (!shell) return;
    if (!categoryToolbarPosition) {
      categoryToolbar = shell;
      categoryToolbarPosition = document.createComment('hc-simple-category-toolbar-position');
      shell.before(categoryToolbarPosition);
    }
    if (shell.parentNode !== tools) {
      const actions = tools.querySelector('.hc-simple-tools__actions');
      if (actions) actions.before(shell); else tools.querySelector('.hc-simple-search')?.after(shell);
    }
  }
  function categoryURL(path, value) {
    const url = new URL(location.href);
    if (path) url.pathname = new URL(path, location.origin).pathname;
    url.searchParams.delete(categoryParam);
    url.searchParams.delete('page');
    if (value) url.searchParams.set(categoryParam, value);
    return url;
  }
  function categoryLink(label, url, selected = false) {
    const link = document.createElement('a'); link.textContent = label; link.href = url;
    link.setAttribute('role', 'radio'); link.setAttribute('aria-checked', String(selected));
    link.tabIndex = selected ? 0 : -1; return link;
  }
  const categoryVehicleLabelSelector = '.hc-simple-toolbar-vehicle [data-mf-shared-label], #MainContent:is([data-template^="collection"], [data-template^="search"]) .hc-simple-vehicle [data-mf-shared-label]';
  function simpleVehicleLabel(label) {
    return String(label || '').replace(/\bHolden\b\s*/gi, '').trim()
      .replace(/^Commodore\s+(VB|VC|VH|VK|VL|VN|VP|VR|VS|VT|VX|VY|VZ|VE|VF)\b/i, (_, series) => `${series.toUpperCase()} Commodore`);
  }
  function syncCategoryVehicleLabels() {
    if (preference !== 'simple') return;
    document.querySelectorAll(categoryVehicleLabelSelector).forEach(label => {
      const text = simpleVehicleLabel(label.textContent);
      if (text !== label.textContent) label.textContent = text;
    });
  }
  function categoryVehicleLabelChanged(record) {
    const element = record.target.nodeType === 3 ? record.target.parentElement : record.target;
    return preference === 'simple' && !!element?.closest?.(categoryVehicleLabelSelector);
  }
  function categoryVehicleButton() {
    const button = document.createElement('button'); button.type = 'button';
    button.className = 'hc-simple-toolbar-vehicle';
    const label = document.createElement('span'); label.dataset.mfSharedLabel = '';
    label.textContent = simpleVehicleLabel(window.Framewerk?.vehicle?.get?.()?.label) || 'VEHICLE'; button.append(label);
    button.dataset.mfDefaultLabel = 'VEHICLE';
    button.dataset.mfTriggerSelector = ''; button.dataset.mfPreserveStyle = '';
    button.dataset.framewerkFilterVehicleSelector = '';
    button.setAttribute('aria-haspopup', 'dialog');
    return button;
  }
  function syncSimpleCategories() {
    const showAllURL = categoryURL('/collections/all');
    const fallback = document.querySelector('#MainContent:is([data-template^="collection"], [data-template^="search"]) .hc-simple-tools__actions > a');
    if (fallback) fallback.href = showAllURL;
    const data = document.querySelector('template[data-hc-simple-category-data]');
    const drawer = document.querySelector('#filters-drawer dialog');
    if (!data || !drawer) return;
    const groups = [...data.content.querySelectorAll('[data-hc-category-group]')];
    if (!groups.length) return;
    const simple = preference === 'simple';
    const relabel = (element, label) => {
      if (!element) return;
      const node = [...element.childNodes].find(n => n.nodeType === 3 && n.textContent.trim());
      if (!node) return;
      if (!categoryText.has(node)) categoryText.set(node, node.textContent);
      node.textContent = simple ? label : categoryText.get(node);
    };
    const trigger = document.querySelector('.framewerk-mobile-filter-button .facets-toggle__button');
    relabel(drawer.querySelector('#filters-drawer-heading'), 'CATEGORY');
    const selectedValue = new URL(location.href).searchParams.get(categoryParam);
    const selectedInput = [...drawer.querySelectorAll('input[name="' + categoryParam + '"]')].find(input => input.value === selectedValue);
    const selectedLink = [...data.content.querySelectorAll('a[href]')].find(link => new URL(link.getAttribute('href'), location.origin).pathname === location.pathname);
    const selectedLabel = selectedValue
      ? selectedInput?.dataset.label || selectedValue
      : selectedLink?.textContent.trim();
    const labelCategory = button => {
      if (!button) return;
      let label = button.querySelector('.hc-simple-category-label');
      if (!label) {
        const text = [...button.childNodes].find(node => node.nodeType === 3 && node.textContent.trim());
        if (!text) return;
        label = document.createElement('span'); label.className = 'hc-simple-category-label';
        label.dataset.originalLabel = text.textContent; text.replaceWith(label);
      }
      const text = simple ? selectedLabel || 'CATEGORY' : label.dataset.originalLabel;
      if (label.textContent !== text) label.textContent = text;
      if (simple && selectedLabel) button.title = selectedLabel;
      else button.removeAttribute('title');
    };
    labelCategory(trigger);
    const mobileBar = trigger?.closest('[data-framewerk-sticky-bar]');
    if (mobileBar && !mobileBar.querySelector('.hc-simple-toolbar-vehicle')) {
      mobileBar.prepend(categoryVehicleButton());
    }
    const desktopBar = document.querySelector('.framewerk-sticky-filters');
    if (desktopBar && !desktopBar.querySelector('.hc-simple-category-controls')) {
      const controls = document.createElement('div'); controls.className = 'hc-simple-category-controls';
      const open = document.createElement('button'); open.type = 'button'; open.textContent = 'CATEGORY'; open.dataset.hcCategoryOpen = '';
      controls.append(categoryVehicleButton(), open);
      const density = desktopBar.querySelector('.column-options-wrapper'); if (density) density.before(controls); else desktopBar.append(controls);
    }
    labelCategory(desktopBar?.querySelector('[data-hc-category-open]'));
    syncCategoryVehicleLabels();
    const nativeVehicle = desktopBar?.querySelector('.framewerk-selected-vehicle');
    let vehicleIdentity = desktopBar?.querySelector('.hc-simple-selected-vehicle-label');
    if (nativeVehicle && !vehicleIdentity) {
      vehicleIdentity = document.createElement('span'); vehicleIdentity.className = 'hc-simple-selected-vehicle-label';
      vehicleIdentity.setAttribute('aria-live', 'polite'); nativeVehicle.before(vehicleIdentity);
    }
    if (vehicleIdentity) {
      const vehicle = window.Framewerk?.vehicle?.get?.();
      const label = vehicle?.label || [vehicle?.make, vehicle?.model, vehicle?.series].filter(Boolean).join(' ');
      vehicleIdentity.textContent = simple ? simpleVehicleLabel(label) : label; vehicleIdentity.hidden = !label;
    }
    const native = drawer.querySelector('accordion-custom[data-filter-param-name="filter-p-m-jci-categories"]');
    if (native) native.dataset.hcCategoryNative = '';
    document.querySelectorAll('.facets:not(.facets--drawer) accordion-custom:is([data-filter-param-name="filter-p-m-jci-categories"], [data-filter-param-name="filter-v-availability"])').forEach(e => { e.dataset.hcCategoryNative = ''; });
    let panel = drawer.querySelector('[data-hc-simple-category-panel]');
    if (!panel) {
      panel = document.createElement('section'); panel.className = 'hc-simple-category-panel'; panel.setAttribute('aria-label', 'Category choices');
      panel.dataset.hcSimpleCategoryPanel = '';
      if (native) native.before(panel);
      else (drawer.querySelector('.facets__filters-wrapper, facets-form-component') || drawer).prepend(panel);
    }
    if (categoryGroup === undefined) {
      let savedGroup;
      try { savedGroup = sessionStorage.getItem('holdcom:simple-category-group:v1'); } catch {}
      // An empty saved group is an explicit return to the primary choices.
      // Infer from the URL only for the initial visit without panel state.
      const matchesPath = a => a && new URL(a.getAttribute('href'), location.origin).pathname === location.pathname;
      const root = groups.find(g => matchesPath(g.querySelector('a')));
      const parent = root || groups.find(g => [...g.querySelectorAll('a')].some(matchesPath));
      categoryGroup = savedGroup ?? parent?.dataset.hcCategoryGroup ?? '';
    }
    if (categoryGroup !== 'other' && !groups.some(g => g.dataset.hcCategoryGroup === categoryGroup)) categoryGroup = '';
    if (categoryGroup === 'other' && !native) categoryGroup = '';
    const signature = location.href + '|' + categoryGroup + '|' + (native?.textContent || '');
    if (panel.dataset.hcCategorySignature !== signature) {
      panel.dataset.hcCategorySignature = signature; panel.replaceChildren();
      const heading = document.createElement('h3'); heading.textContent = categoryGroup ? groups.find(g => g.dataset.hcCategoryGroup === categoryGroup)?.querySelector('a').textContent : 'Choose a category'; panel.append(heading);
      const choices = document.createElement('div'); choices.className = 'hc-simple-category-choices';
      if (!categoryGroup) {
        groups.forEach(group => {
          const button = document.createElement('button'); button.type = 'button'; button.textContent = group.dataset.hcCategoryLabel || group.querySelector('a').textContent; button.dataset.hcCategoryGroupChoice = group.dataset.hcCategoryGroup; choices.append(button);
        });
        if (native) { const more = document.createElement('button'); more.type = 'button'; more.textContent = 'ALL CATEGORIES'; more.dataset.hcCategoryGroupChoice = 'other'; choices.append(more); }
      } else {
        const back = document.createElement('button'); back.type = 'button'; back.textContent = '← BACK TO CATEGORIES'; back.dataset.hcCategoryBack = ''; panel.append(back);
        choices.setAttribute('role', 'radiogroup'); choices.setAttribute('aria-label', 'Choose one category');
        const activeValue = new URL(location.href).searchParams.get(categoryParam);
        if (categoryGroup === 'other') {
          heading.textContent = 'ALL CATEGORIES';
          [...native?.querySelectorAll('input[type="checkbox"]') || []].forEach(input => {
            const label = input.dataset.label || drawer.querySelector('label[for="' + CSS.escape(input.id) + '"]')?.textContent.trim() || input.value;
            choices.append(categoryLink(label, categoryURL('/collections/all', input.value), activeValue === input.value));
          });
        } else {
          const group = groups.find(g => g.dataset.hcCategoryGroup === categoryGroup);
          [...group.querySelectorAll('a')].forEach((source, index) => {
            const url = categoryURL(source.getAttribute('href'));
            const label = index === 0 ? 'All ' + source.textContent : source.textContent;
            const choice = categoryLink(label, url, !activeValue && url.pathname === location.pathname);
            choice.dataset.hcCategoryId = source.dataset.hcCategoryId; choices.append(choice);
          });
        }
        const all = categoryLink('ALL PARTS', showAllURL, location.pathname === '/collections/all' && !activeValue); choices.append(all);
        if (!choices.querySelector('[tabindex="0"]')) choices.querySelector('[role="radio"]')?.setAttribute('tabindex', '0');
      }
      panel.append(choices);
      if (!categoryGroup) {
        const reset = document.createElement('a'); reset.textContent = 'ALL PARTS'; reset.href = showAllURL; panel.append(reset);
      }
    }
    const availability = drawer.querySelector('accordion-custom[data-filter-param-name="filter-v-availability"]');
    if (availability) {
      availability.dataset.hcCategoryNative = '';
      const current = new URL(location.href).searchParams.get('filter.v.availability') || '';
      let options = drawer.querySelector('[data-hc-simple-availability]');
      if (!options) { options = document.createElement('section'); options.className = 'hc-simple-category-panel'; options.dataset.hcSimpleAvailability = ''; availability.before(options); }
      if (options.dataset.value !== current) {
        options.dataset.value = current; options.replaceChildren();
        const heading = document.createElement('h3'); heading.textContent = 'Availability';
        const choices = document.createElement('div'); choices.className = 'hc-simple-category-choices'; choices.setAttribute('role', 'radiogroup'); choices.setAttribute('aria-label', 'Availability');
        [['', 'Any availability'], ['1', 'In stock'], ['0', 'Out of stock']].forEach(([value, label]) => {
          const url = new URL(location.href); url.searchParams.delete('page'); url.searchParams.delete('filter.v.availability'); if (value) url.searchParams.set('filter.v.availability', value);
          const choice = categoryLink(label, url, current === value); choice.dataset.hcAvailabilityChoice = value; choices.append(choice);
        }); options.append(heading, choices);
      }
    }
    const ResultsList = customElements.get('results-list');
    document.querySelectorAll('results-list').forEach(list => {
      if (!simple) {
        list.querySelectorAll('.hc-simple-pagination-recovery').forEach(recovery => { const pagination = recovery.querySelector('.pagination'); if (pagination) recovery.before(pagination); recovery.remove(); });
        delete list.dataset.hcSimplePaginationReady; return;
      }
      // Native history renders remove the initialization attribute while the
      // upgraded element and its pagination controller remain connected.
      if (!ResultsList || !(list instanceof ResultsList)) return;
      const pagination = list.querySelector('.pagination:not(.hc-simple-pagination-recovery .pagination)');
      if (!pagination || !list.querySelector('[ref="viewMoreNext"], [ref="viewMorePrevious"], .product-grid__show-more-link')) return;
      if (!list.querySelector('.hc-simple-pagination-recovery')) {
        const recovery = document.createElement('details'); recovery.className = 'hc-simple-pagination-recovery';
        const summary = document.createElement('summary'); summary.textContent = 'More loading options'; pagination.before(recovery); recovery.append(summary, pagination);
      }
      list.dataset.hcSimplePaginationReady = '';
    });
  }
  function apply(value, save = false, source = 'sync') {
    if (save) explicitPreference = value;
    const changed = value !== preference;
    if (changed) flushModeTime();
    preference = value;
    if (changed) resetModeInterval();
    root.classList.toggle('hc-simple-view', value === 'simple');
    syncProduct();
    syncFeeds();
    syncHomepageHero();
    syncSimpleCategories();
    syncCategoryToolbar();
    trackMode(source);
    if (save) {
      try { localStorage.setItem(key, value); } catch {}
      try { document.cookie = 'hc_browsing_view=' + value + '; Path=/; Max-Age=31536000; SameSite=Lax; Secure'; } catch {}
    }
    document.querySelectorAll('[data-hc-simple-toggle]').forEach(button => {
      const pressed = String(value === 'simple');
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      const label = button.querySelector('[data-hc-simple-toggle-state]');
      const text = value === 'simple' ? 'On' : 'Off';
      if (label.textContent !== text) label.textContent = text;
    });
  }
  const inventoryPositions = new Map();
  function syncProductAvailability(product) {
    for (const [inventory, state] of inventoryPositions) {
      if (!inventory.isConnected) {
        const current = inventory.isConnected ? inventory : state.row.querySelector('product-inventory');
        if (current?.isConnected && state.anchor.isConnected) state.anchor.replaceWith(current);
        else state.anchor.remove();
        state.row.remove();
        inventoryPositions.delete(inventory);
      }
    }
    const inventory = product.querySelector('product-inventory');
    const metadata = product.querySelector('[class^="ai-product-brand-content-"]');
    const sourceRow = metadata?.querySelector('[class^="ai-product-brand-row-"]');
    if (!inventory || !sourceRow || inventoryPositions.has(inventory)) return;
    const labelSource = sourceRow.querySelector('[class^="ai-product-brand-label-"]');
    const valueSource = sourceRow.querySelector('[class^="ai-product-brand-value-"]');
    if (!labelSource || !valueSource) return;
    const anchor = document.createComment('Original product availability position');
    const row = document.createElement('div');
    row.className = sourceRow.className;
    row.dataset.hcMobileAvailability = '';
    const label = document.createElement('span');
    label.className = labelSource.className;
    label.textContent = 'Availability:';
    const value = document.createElement('div');
    value.className = valueSource.className;
    inventory.before(anchor);
    value.append(inventory);
    row.append(label, value);
    metadata.append(row);
    inventoryPositions.set(inventory, { anchor, row });
  }
  const expanded = new Map();
  const descriptionSummaries = new WeakMap();
  function syncProduct() {
    const active = preference === 'simple' && mobile.matches;
    const product = document.querySelector('#MainContent[data-template="product"] .product-details');
    if (!product) return;
    syncProductAvailability(product);
    const buy = product.querySelector('.buy-buttons-block');
    const options = product.querySelector('variant-picker, .fwpo-root');
    const optionalExtras = options?.matches('.fwpo-root');
    // This generated step label also supplies its numbered badge. Optional
    // Add-ons keeps its own accordion heading and all existing option controls.
    if (optionalExtras) product.querySelector('[data-hc-product-intro]')?.remove();
    if (buy && !optionalExtras && !product.querySelector('[data-hc-product-intro]')) {
      const heading = document.createElement('h2');
      heading.className = 'hc-simple-step'; heading.dataset.hcProductIntro = '';
      heading.textContent = 'SIMILAR PRODUCTS';
      (options || buy).before(heading);
    }
    const rows = [...product.querySelectorAll('.accordion details.details')];
    rows.forEach(row => {
      const description = row.querySelector(':scope > summary .details__heading')?.textContent.trim().toLowerCase() === 'product description';
      const desktopDescription = description && !mobile.matches && !row.closest('accordion-custom')?.hidden;
      if (description && !descriptionSummaries.has(row)) {
        const summary = row.querySelector(':scope > summary');
        if (summary) {
          descriptionSummaries.set(row, { summary, tabindex: summary.getAttribute('tabindex'), disabled: summary.getAttribute('aria-disabled') });
          summary.addEventListener('click', event => { if (row.hasAttribute('data-hc-desktop-description')) event.preventDefault(); });
          row.addEventListener('toggle', () => { if (row.hasAttribute('data-hc-desktop-description') && !mobile.matches) row.open = true; });
        }
      }
      row.toggleAttribute('data-hc-desktop-description', desktopDescription);
      const state = descriptionSummaries.get(row);
      if (state) {
        for (const [name, value] of [['tabindex', desktopDescription ? '-1' : state.tabindex], ['aria-disabled', desktopDescription ? 'true' : state.disabled]]) {
          if (value === null) state.summary.removeAttribute(name); else state.summary.setAttribute(name, value);
        }
      }
      if (active || desktopDescription) {
        if (!expanded.has(row)) { expanded.set(row, row.open); row.open = true; }
        if (desktopDescription) row.open = true;
      } else if (expanded.has(row)) {
        row.open = expanded.get(row);
        expanded.delete(row);
      }
    });
    for (const row of expanded.keys()) { if (!row.isConnected) expanded.delete(row); }
  }
  const feeds = new Map();
  function syncFeeds() {
    const active = preference === 'simple' && mobile.matches;
    for (const [grid, state] of feeds) {
      if (!active || !grid.isConnected || state.context !== location.pathname + location.search) {
        state.observer.disconnect(); state.abort?.abort(); state.list.classList.remove('hc-simple-feed'); state.status.remove(); feeds.delete(grid);
      }
    }
    if (!active || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('results-list').forEach(list => {
      const grid = list.querySelector('[ref="grid"]');
      // Leave already-enabled native infinite scrolling in charge.
      if (!grid || feeds.has(grid) || list.querySelector('[ref="viewMoreNext"]') || !grid.querySelector('.product-grid__show-more-link')) return;
      const status = document.createElement('p');
      status.className = 'hc-simple-feed-status'; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); grid.after(status);
      const state = { list, status, context: location.pathname + location.search, busy: false, failed: false, abort: null, observer: null, link: null };
      const current = () => feeds.get(grid) === state && preference === 'simple' && mobile.matches && grid.isConnected && state.context === location.pathname + location.search;
      const nextLink = () => grid.querySelector('.product-grid__show-more-link');
      function observeNext() {
        state.observer.disconnect();
        const link = nextLink();
        if (link) {
          if (state.link !== link) {
            state.link = link;
            link.addEventListener('click', event => { if (!current()) return; event.preventDefault(); state.failed = false; load(); });
          }
          state.observer.observe(link);
        }
      }
      async function load() {
        const link = nextLink();
        if (!current() || state.busy || !link) return;
        const url = new URL(link.href, location.href);
        const expected = new URL(location.href);
        const normalise = value => { const copy = new URL(value); copy.searchParams.delete('page'); copy.searchParams.delete('section_id'); copy.searchParams.sort(); return copy.pathname + copy.search; };
        if (url.origin !== location.origin || normalise(url) !== normalise(expected)) return;
        state.busy = true; state.abort = new AbortController();
        const timeout = setTimeout(() => state.abort.abort(), 15000);
        const originalText = link.innerHTML;
        link.textContent = 'Loading more parts…'; link.setAttribute('aria-disabled', 'true'); status.textContent = 'Loading more matching parts…';
        try {
          const section = list.getAttribute('section-id'); if (section) url.searchParams.set('section_id', section);
          const response = await fetch(url.href, { credentials: 'same-origin', signal: state.abort.signal });
          if (!response.ok) throw new Error('Parts could not be loaded');
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!current() || nextLink() !== link) return;
          const incoming = page.querySelector('[ref="grid"]');
          if (!incoming) throw new Error('Missing product results');
          const existing = new Set([...grid.querySelectorAll('[data-product-id]')].map(card => card.dataset.productId));
          const cards = [...incoming.querySelectorAll(':scope > [data-product-id]')].filter(card => !existing.has(card.dataset.productId));
          if (!cards.length) throw new Error('No new parts returned');
          const scrollPosition = window.scrollY;
          const item = link.closest('.product-grid__show-more-item');
          item.before(...cards);
          const next = incoming.querySelector('.product-grid__show-more-item');
          if (next) item.replaceWith(next); else item.remove();
          const oldPagination = list.querySelector('.pagination');
          const newPagination = page.querySelector('.pagination');
          if (oldPagination && newPagination) oldPagination.replaceWith(newPagination);
          else if (oldPagination) oldPagination.remove();
          status.textContent = next ? cards.length + ' more parts loaded' : 'You’ve reached the end of the matching parts.';
          // Appending below existing products must not follow a moved footer
          // or load-more control chosen by browser scroll anchoring.
          grid.getBoundingClientRect();
          if (window.scrollY !== scrollPosition) window.scrollTo({ top: scrollPosition, behavior: 'instant' });
          state.failed = false;
        } catch (error) {
          if (!current()) return;
          state.failed = true; status.textContent = 'Couldn’t load more parts. Tap below to try again.'; link.textContent = 'Try loading more';
        } finally {
          clearTimeout(timeout);
          state.busy = false; link.removeAttribute('aria-disabled');
          if (link.isConnected && !state.failed) link.innerHTML = originalText;
          if (current()) observeNext();
        }
      }
      state.observer = new IntersectionObserver(entries => { if (!state.failed && entries.some(entry => entry.isIntersecting)) load(); }, { rootMargin: '0px 0px 500px 0px' });
      feeds.set(grid, state); list.classList.add('hc-simple-feed'); observeNext();
    });
  }
  function boot() {
    const dialog = document.querySelector('.hc-view-choice');
    if (!dialog) return;
    function close() { dialog.close(); if (opener?.isConnected) opener.focus({ preventScroll: true }); }
    function open(source) {
      if (!mobile.matches || dialog.open) return;
      opener = source;
      dialog.showModal();
    }
    document.addEventListener('click', event => {
      const group = event.target.closest('[data-hc-category-group-choice]');
      const back = event.target.closest('[data-hc-category-back]');
      if ((!group && !back) || preference !== 'simple') return;
      // The native outside-click handler must see this as an internal action,
      // even though rendering the next choices removes the clicked element.
      event.preventDefault(); event.stopPropagation();
      categoryGroup = group?.dataset.hcCategoryGroupChoice || '';
      try { sessionStorage.setItem('holdcom:simple-category-group:v1', categoryGroup); } catch {}
      syncSimpleCategories(); document.querySelector('.hc-simple-category-panel button, .hc-simple-category-panel [tabindex="0"]')?.focus();
    }, true);
    document.addEventListener('click', event => {
      if (event.target.closest('[data-hc-category-open]')) document.querySelector('.framewerk-mobile-filter-button .facets-toggle__button')?.click();
      const availability = event.target.closest('[data-hc-availability-choice]');
      if (availability && preference === 'simple') {
        const component = availability.closest('facets-form-component');
        if (typeof component?.updateFiltersByURL === 'function') {
          event.preventDefault(); component.querySelectorAll('input[name="filter.v.availability"]').forEach(input => { input.checked = input.value === availability.dataset.hcAvailabilityChoice; });
          component.updateFiltersByURL(availability.href);
        }
      }
      if (preference !== 'simple' || !mobile.matches || !event.target.closest('.mf-vehicle-option')) return;
      const modal = event.target.closest('.mf-modal');
      requestAnimationFrame(() => modal?.querySelector('[data-mf-show-matching]:not([hidden])')?.click());
    }, true);
    document.addEventListener('click', event => {
      if (event.target.closest('[data-hc-simple-chat]')) {
        const chat = document.querySelector('.fw-ai-root:not([hidden]) .fw-ai-launch, .fw-live-root:not([hidden]) .fw-live-launch:not([hidden])');
        chat?.click();
      }
      if (event.target.closest('[data-hc-simple-menu]')) requestAnimationFrame(() => document.querySelector('.framewerk-header__menu-button')?.click());
      if (event.target.closest('[data-hc-simple-cart]')) {
        const cart = document.querySelector('a[on\\:click="#cart-drawer/open"]');
        if (cart) { event.preventDefault(); requestAnimationFrame(() => cart.click()); }
      }
      if (event.target.closest('[data-hc-simple-wishlist]')) requestAnimationFrame(() => document.querySelector('.framewerk-wishlist-trigger')?.click());
      const choice = event.target.closest('[data-hc-view-choice]');
      if (choice) { apply(choice.dataset.hcViewChoice, true, 'choice'); close(); }
      if (event.target.closest('[data-hc-view-dismiss]')) { apply(preference || 'standard', true); close(); }
      const toggle = event.target.closest('[data-hc-simple-toggle]');
      if (toggle) apply(preference === 'simple' ? 'standard' : 'simple', true, 'toggle');
      const settings = event.target.closest('[data-hc-view-settings]');
      if (settings) open(settings);
      if (event.target.closest('[data-hc-simple-filter]')) {
        const trigger = document.querySelector('.framewerk-mobile-filter-button .facets-toggle__button');
        trigger?.click();
      }
    });
    document.addEventListener('keydown', event => {
      const choice = event.target.closest('.hc-simple-category-choices [role="radio"]');
      if (!choice || preference !== 'simple') return;
      if (event.key === ' ') { event.preventDefault(); choice.click(); return; }
      if (!['ArrowDown', 'ArrowUp', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      const radios = [...choice.parentElement.querySelectorAll('[role="radio"]')];
      const index = radios.indexOf(choice), forward = ['ArrowDown', 'ArrowRight'].includes(event.key);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? radios.length - 1 : (index + (forward ? 1 : -1) + radios.length) % radios.length;
      radios.forEach(r => { r.tabIndex = -1; }); radios[next].tabIndex = 0; radios[next].focus();
    });
    dialog.addEventListener('cancel', () => apply(preference || 'standard', true));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientY < rect.top || event.clientY > rect.bottom || event.clientX < rect.left || event.clientX > rect.right) { apply(preference || 'standard', true); close(); }
    });
    function sync() {
      let chat = document.querySelector('[data-hc-simple-chat]');
      const available = document.querySelector('.fw-ai-root:not([hidden]) .fw-ai-launch, .fw-live-root:not([hidden]) .fw-live-launch:not([hidden])');
      if (available && !chat) {
        chat = document.createElement('button');
        chat.type = 'button'; chat.className = 'hc-simple-chat'; chat.dataset.hcSimpleChat = '';
        chat.setAttribute('aria-label', 'Open chat');
        chat.textContent = 'CHAT';
        document.body.append(chat);
      }
      if (chat) chat.hidden = !available;
      document.querySelectorAll('.menu-drawer__navigation, .framewerk-header-menu--mobile .framewerk-header-menu__panel--level-0 > .framewerk-header-menu__container').forEach(nav => {
        if (nav.querySelector('[data-hc-simple-toggle]')) return;
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'hc-simple-menu-toggle'; button.dataset.hcSimpleToggle = '';
        button.innerHTML = '<span>Simple mode<span class="hc-simple-tags"><span>NEW!</span><span>EXPERIMENTAL</span></span><small>Bigger buttons &amp; easier reading</small></span><span data-hc-simple-toggle-state></span>';
        const header = nav.querySelector(':scope > .framewerk-header-menu__panel-header');
        const menu = nav.querySelector(':scope > .framewerk-header-menu__menu');
        nav.append(button);
        const home = document.createElement('a');
        home.href = window.Shopify?.routes?.root || '/';
        home.className = 'hc-simple-menu-shortcut'; home.textContent = 'Home';
        const shortcuts = [home];
        const accountSource = document.querySelector('.framewerk-header__icon-buttons a[href*="/account"]');
        if (accountSource) {
          const account = document.createElement('a'); account.href = accountSource.href;
          account.className = 'hc-simple-menu-shortcut'; account.textContent = 'Account';
          shortcuts.push(account);
        }
        const wishlist = document.createElement('button');
        wishlist.type = 'button'; wishlist.className = 'hc-simple-menu-wishlist';
        wishlist.dataset.hcSimpleWishlist = ''; wishlist.textContent = 'Wishlist';
        shortcuts.push(wishlist);
        if (menu) {
          const items = [...menu.children];
          const label = item => item.querySelector(':scope > .framewerk-header-menu__link > span:not(.svg-wrapper)');
          const products = items.find(item => /^(products|shop all|shop)$/i.test(label(item)?.textContent.trim()));
          const models = items.find(item => /^search by model$/i.test(label(item)?.textContent.trim()));
          if (products) label(products).textContent = 'Shop';
          const leading = [products, models].filter(Boolean);
          if (leading.length) menu.prepend(...leading);
          const shortcutItems = shortcuts.map(shortcut => {
            const item = document.createElement('li');
            item.className = 'framewerk-header-menu__item hc-simple-menu-shortcut-item';
            item.append(shortcut); return item;
          });
          const lastLeading = leading[leading.length - 1];
          if (lastLeading) lastLeading.after(...shortcutItems); else menu.prepend(...shortcutItems);
        } else if (header) header.after(...shortcuts);
        else nav.prepend(...shortcuts);
      });
      const filter = document.querySelector('[data-hc-simple-filter]');
      const native = document.querySelector('.framewerk-mobile-filter-button .facets-toggle__button');
      if (filter) filter.hidden = !native;
      const summary = document.querySelector('[data-hc-simple-filter-summary]');
      const count = native?.querySelector('.filter-count')?.textContent?.trim();
      if (summary) { summary.hidden = !count; summary.textContent = count ? count + ' filters selected — tap Filter by to change' : ''; }
      apply(preference);
    }
    document.querySelector('[data-hc-view-choice="simple"] strong')?.insertAdjacentHTML('afterend', '<span class="hc-simple-tags"><span>NEW!</span><span>EXPERIMENTAL</span></span>');
    sync();
    trackMode();
    setInterval(() => { flushModeTime(); resetModeInterval(); }, 15000);
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(name => document.addEventListener(name, () => {
      const now = performance.now();
      if (now > lastActivity + 60000) { flushModeTime(); activeSince = now; }
      lastActivity = now;
    }, { passive: true }));
    const updateForeground = () => { flushModeTime(); foreground = !document.hidden && document.hasFocus(); resetModeInterval(); if (foreground) { lastActivity = activeSince; trackMode(); } };
    document.addEventListener('visibilitychange', updateForeground);
    window.addEventListener('focus', updateForeground);
    window.addEventListener('blur', updateForeground);
    window.addEventListener('pagehide', () => { flushModeTime(); foreground = false; resetModeInterval(); });
    window.addEventListener('pageshow', updateForeground);
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => { const wasEligible = interval.eligible; flushModeTime(); resetModeInterval(); if (!wasEligible && interval.eligible) lastActivity = activeSince; if (!error) trackMode(); });
    document.addEventListener('visitorConsentCollected', () => { flushModeTime(); resetModeInterval(); if (!analyticsAllowed()) trackedMode = undefined; else { if (foreground) lastActivity = activeSince; trackMode(); } });
    customElements.whenDefined('accordion-custom').then(() => {
      if (preference === 'simple' && mobile.matches) expanded.forEach((_, row) => { if (row.isConnected) row.open = true; });
      syncProduct();
    });
    customElements.whenDefined('results-list').then(() => apply(preference));
    window.addEventListener('framewerk:ready', syncSimpleCategories);
    window.addEventListener('framewerk:vehicle:changed', syncSimpleCategories);
    // Third-party widgets can change frequently without affecting these controls.
    // Only rescan when a component we enhance is inserted or replaced.
    const syncTargets = '.product-details, product-inventory, variant-picker, .fwpo-root, .buy-buttons-block, .accordion, .product-details .accordion accordion-custom, .product-details .accordion details.details, results-list, #MainContent, .slideshow-section, [data-framewerk-sticky-shell], .framewerk-sticky-filters, #filters-drawer, .facets-toggle__button, .menu-drawer__navigation, .framewerk-header-menu__container, .fw-ai-root, .fw-ai-launch, .fw-live-root, .fw-live-launch';
    const touchesSyncTarget = node => node.nodeType === 1 && (node.matches(syncTargets) || node.querySelector(syncTargets));
    let queued = false;
    new MutationObserver(records => {
      if (records.some(categoryVehicleLabelChanged)) syncCategoryVehicleLabels();
      if (queued || !records.some(record => [...record.addedNodes, ...record.removedNodes].some(touchesSyncTarget))) return;
      queued = true; requestAnimationFrame(() => { queued = false; sync(); });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
    // An unsaved default follows the breakpoint; explicit choices remain in charge.
    mobile.addEventListener('change', () => {
      const restore = mobile.matches ? [...expanded].filter(([row]) => row.hasAttribute('data-hc-desktop-description')) : [];
      flushModeTime(); apply(resolvedPreference()); resetModeInterval(); if (!mobile.matches && dialog.open) close();
      requestAnimationFrame(() => {
        if (mobile.matches && preference !== 'simple') restore.forEach(([row, open]) => { if (row.isConnected) row.open = open; });
        syncProduct();
      });
    });
    let heroResizeQueued = false;
    window.addEventListener('resize', () => {
      if (heroResizeQueued) return;
      heroResizeQueued = true;
      requestAnimationFrame(() => { heroResizeQueued = false; syncHomepageHero(); });
    }, { passive: true });
    document.fonts?.ready.then(syncHomepageHero);
    window.addEventListener('storage', event => { if (event.key === key || event.key === null) { explicitPreference = readPreference(); apply(resolvedPreference()); } });
    window.addEventListener('pageshow', () => { explicitPreference = readPreference() || explicitPreference; apply(resolvedPreference()); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
